"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldMenu = void 0;
const definables_1 = require("definables");
const pixel_pigeon_1 = require("pixel-pigeon");
class WorldMenu extends definables_1.Definable {
    constructor(options) {
        var _a;
        super();
        this._hudElementReferences = null;
        this._openOptions = null;
        this._state = null;
        this._create = options.create;
        this._initialStateValues = options.initialStateValues;
        this._onClose = options.onClose;
        this._preventsWalking = (_a = options.preventsWalking) !== null && _a !== void 0 ? _a : false;
    }
    get openOptions() {
        if (this._openOptions !== null) {
            return this._openOptions;
        }
        throw new Error(this.getAccessorErrorMessage("openOptions"));
    }
    get preventsWalking() {
        return this._preventsWalking;
    }
    get state() {
        if (this._state !== null) {
            return this._state;
        }
        throw new Error(this.getAccessorErrorMessage("state"));
    }
    close() {
        if (this.isOpen() === false) {
            throw new Error("Attempted to close a world menu that is already closed.");
        }
        if (this._hudElementReferences === null) {
            throw new Error("HUDElementReferences is null.");
        }
        if (typeof this._onClose !== "undefined") {
            this._onClose();
        }
        (0, pixel_pigeon_1.removeHUDElements)(this._hudElementReferences);
        this._hudElementReferences = null;
        this._state = null;
        this._openOptions = null;
    }
    isOpen() {
        return this._hudElementReferences !== null;
    }
    open(options) {
        if (this.isOpen()) {
            throw new Error("Attempted to open a world menu that is already open.");
        }
        this._hudElementReferences = this._create(options);
        this._openOptions = options;
        this._state = new pixel_pigeon_1.State(this._initialStateValues);
    }
}
exports.WorldMenu = WorldMenu;
